export const LOGGED_USERS_FALLBACK_DEST_FIELD = "semusuarioslogados";
export const LOGGED_USERS_FALLBACK_TARGET_FIELD = "semusuarioslogadosalvo";

const DEST_FROM_STORED = {
  fila: "fila_humano",
  fila_humano: "fila_humano",
  queue: "fila_humano",
  usuarios: "humano",
  usuario: "humano",
  humano: "humano",
  human: "humano",
  agente: "agente_ia",
  agente_ia: "agente_ia",
  agent: "agente_ia",
  chatbot: "chatbot",
};

const DEST_TO_AUTOMATION = {
  fila_humano: "fila",
  humano: "usuarios",
  agente_ia: "agente",
  chatbot: "chatbot",
};

export function isLoggedUsersOnlyValue(value) {
  if (value === true || value === 1) return true;
  const s = String(value ?? "")
    .trim()
    .toLowerCase();
  return ["1", "true", "sim", "s", "yes", "on"].includes(s);
}

export function normalizeLoggedUsersFallback(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const dest = DEST_FROM_STORED[String(raw.dest || raw.type || "").trim().toLowerCase()] || null;
  if (!dest) return null;
  const target = raw.target_id ?? raw.id ?? raw.alvo ?? "";
  const target_id = target != null ? String(target).trim() : "";
  if (dest === "fila_humano") return { dest, target_id: "" };
  return { dest, target_id };
}

export function fallbackForDisplay(raw) {
  return normalizeLoggedUsersFallback(raw) || { dest: "fila_humano", target_id: "" };
}

export function automationValuesToFallback(values = {}) {
  const destRaw = values?.[LOGGED_USERS_FALLBACK_DEST_FIELD];
  if (destRaw == null || String(destRaw).trim() === "") {
    return { dest: "fila_humano", target_id: "", configured: false };
  }
  const parsed = normalizeLoggedUsersFallback({
    dest: destRaw,
    target_id: values?.[LOGGED_USERS_FALLBACK_TARGET_FIELD],
  });
  return {
    ...(parsed || { dest: "fila_humano", target_id: "" }),
    configured: true,
  };
}

export function applyLoggedUsersOnlyFlag(target = {}, checked) {
  return {
    ...target,
    logged_users_only: checked === true,
    logged_users_fallback: checked
      ? normalizeLoggedUsersFallback(target?.logged_users_fallback) || {
          dest: "fila_humano",
          target_id: "",
        }
      : null,
  };
}

export function fallbackToAutomationFields(fallback) {
  const parsed = fallbackForDisplay(fallback);
  return {
    [LOGGED_USERS_FALLBACK_DEST_FIELD]: DEST_TO_AUTOMATION[parsed.dest] || "fila",
    [LOGGED_USERS_FALLBACK_TARGET_FIELD]: parsed.dest === "fila_humano" ? "" : parsed.target_id || "",
  };
}
